export default __webpack_public_path__ + "static/LOGO_KA_gold-01-eb526e2ecf9c24872711c6a668ded5ef.jpg";